<div *ngIf="loaded; else spinner" class="contact-self-service-wrapper"
  [style.backgroundImage]="settings?.background ? 'url(data:image/jpeg;base64,'+  settings?.background +')' : null">
  <div class="form-container">
    <div [ngClass]="settings?.logoPositioning">
      <img *ngIf="settings?.logo" [src]="settings?.logoBase64" alt="Logo" class="logo">
    </div>
    <h1 class="header">{{ 'MAIN.TITLE' | translate }}</h1>
    <div class="content">
      <p
        [innerHtml]="(settings?.defaultContent.length > 0 ? settings?.defaultContent : settings?.landingContent) | safehtml">
      </p>
    </div>
    <form [formGroup]="emailGroup" (ngSubmit)="submit()">
      <p class="error" role="region" id="error-message-1" *ngIf="errorMessage?.length > 0" aria-atomic="true" aria-live="polite" >{{'ERROR.EMAIL.EMAIL_NOT_ALLOWED' | translate}}</p>
      <p class="error" role="region" id="error-message-2" *ngIf="emailGroup.invalid && !emailGroup.pristine" aria-atomic="true" aria-live="polite">{{'ERROR.EMAIL.EMAIL_INVALID' | translate}}</p>
      <input type="email" formControlName="emailControl" placeholder="{{'FIELD.EMAIL.EMAIL_PLACEHOLDER' | translate }}">
    </form>
    <button class="btn btn-block" type="submit" (click)="submit()"
      [disabled]="checkSubmitState()">{{'BUTTON.SUBMIT' | translate}}</button>
    <div class="content">
      <p [innerHtml]="settings?.footerContent | safehtml"></p>
    </div>
    <app-footer customFooterClass="landing-email-screen"></app-footer>
  </div>
</div>


<ng-template #spinner>
  <div class="spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>
